// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { THEMATIC_DOSSIER_STATUS } from "../../../../utils/Constant";
import { ThematicDossierStatusTagProps } from "../../../types/ThematicDossierTypes";

const ThematicDossierStatusTag: React.FunctionComponent<ThematicDossierStatusTagProps> = (
  props: ThematicDossierStatusTagProps
) => {
  const { publicationDate } = props;

  const thematicDossierStatus = publicationDate
    ? THEMATIC_DOSSIER_STATUS.PUBLISHED
    : THEMATIC_DOSSIER_STATUS.UNPUBLISHED;

  return (
    <Tag color={thematicDossierStatus.color}>{thematicDossierStatus.label}</Tag>
  );
};

export default ThematicDossierStatusTag;
